export default __webpack_public_path__ + "static/media/Kaiku_business_fallback.61c5b103.png";